<template>
  <div>
    <LoadingOverlay v-if="!rendered" />
    <div
      v-else-if="rendered && !verPerfil"
      class="content relative table-wrapper"
    >
      <base-header class="pb-6">
        <b-row align-v="center" class="py-4">
          <b-col cols="7" lg="6">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">Lista de Clientes</h6> -->
            <base-button
              size="md"
              type="neutral"
              @click="verFiltros = !verFiltros"
              >Filtros</base-button
            >
          </b-col>
          <b-col lg="6" cols="5" class="text-right">
            <base-button size="md" type="neutral">Enviar Mensagem</base-button>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div>
              <b-col
                cols="12"
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>

                <div>
                  <base-input
                    v-model="searchQuery"
                    prepend-icon="fas fa-search"
                    placeholder="Pesquisa..."
                  >
                  </base-input>
                </div>
              </b-col>
              <el-table
                :data="queriedData"
                row-key="id"
                header-row-class-name="thead-light"
                @sort-change="sortChange"
                @selection-change="selectionChange"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                >
                </el-table-column>
                <el-table-column align="right" label="">
                  <div slot-scope="{ row }" class="d-flex">
                    <base-button
                      @click.native="verPerfilCliente(row)"
                      class="btn-link bg-orange secondary"
                      type="secondary"
                      size="md"
                    >
                      Ver perfil
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="">
                <p class="card-category">
                  A mostrar {{ from + 1 }} - {{ to }} de {{ total }} entradas

                  <span v-if="selectedRows.length">
                    &nbsp; &nbsp; {{ selectedRows.length }} Linhas selecionadas
                  </span>
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
              >
              </base-pagination>
            </div>
          </card>
        </div>
      </b-container>
    </div>

    <div v-else-if="rendered && verPerfil && !verFiltros" class="content">
      <base-header class="pb-6">
        <b-row align-v="center" class="py-4">
          <b-col cols="7" lg="6">
            <h6 class="h2 d-inline-block mb-0">Perfil de Cliente</h6>
          </b-col>
          <b-col lg="6" cols="5" class="text-right">
            <base-button
              @click="verPerfil = !verPerfil"
              size="md"
              type="neutral"
              >Voltar</base-button
            >
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
          <card class="no-border-card" body-classes="px-0 pb-1">
            <div class="px-3"><h2>Resumo</h2></div>

            <b-row class="px-3 pt-3">
              <b-col cols="12" lg="6" class="mb-1">
                <card class="no-border-card">
                  <h3>{{ dadosClienteSelecionado.nome }}</h3>
                  <b-row class="px-3">
                    <h4>
                      {{
                        calcularIdade(dadosClienteSelecionado.data_nascimento)
                      }}
                      anos | {{ dadosClienteSelecionado.email }} |
                      {{ dadosClienteSelecionado.telefone }}
                    </h4>
                  </b-row>
                </card>
              </b-col>
              <b-col cols="12" lg="3" class="mb-1">
                <card class="no-border-card">
                  <h3>Última Visita</h3>
                  <b-row class="px-3">
                    <h2 class="numberResult">
                      {{ tempoDesde(dadosClienteSelecionado.ultima_visita) }}
                    </h2>
                  </b-row>
                </card>
              </b-col>
              <b-col cols="12" lg="3" class="mb-1">
                <card class="no-border-card">
                  <h3>Cartão Criado</h3>
                  <b-row class="px-3">
                    <h2 class="numberResult">
                      {{ tempoDesde(dadosClienteSelecionado.dt_created) }}
                    </h2>
                  </b-row>
                </card>
              </b-col>
            </b-row>
            <b-row class="px-3">
              <b-col cols="12" lg="3" class="mb-1">
                <card class="no-border-card">
                  <b-col cols="12" lg="12" class="mb-1">
                    <base-button size="md" type="primary" class="w-100"
                      >Enviar Mensagem</base-button
                    >
                  </b-col>
                  <b-col cols="12" lg="12" class="mb-1 mt-3">
                    <base-button size="md" type="primary" class="w-100"
                      >Histórico de Mensagens</base-button
                    >
                  </b-col>
                </card>
              </b-col>
              <b-col cols="12" lg="3" class="mb-1">
                <card class="no-border-card">
                  <b-row>
                    <b-col cols="6" lg="6" class="mb-1">
                      <h3>Desconto</h3>
                    </b-col>
                    <b-col cols="6" lg="6" class="mb-1 text-right text-orange">
                      <i class="ni ni-ruler-pencil"></i>
                    </b-col>
                  </b-row>

                  <b-row class="px-3">
                    <h2 class="numberResult">
                      {{ dadosClienteSelecionado.desconto }}%
                    </h2>
                  </b-row>
                </card>
              </b-col>

              <b-col cols="12" lg="3" class="mb-1">
                <card class="no-border-card">
                  <h3>Número de Envios</h3>
                  <b-row class="px-3">
                    <h2 class="numberResult">7</h2>
                  </b-row>
                </card>
              </b-col>
              <b-col cols="12" lg="3" class="mb-1">
                <card class="no-border-card">
                  <h3>Último Envio</h3>
                  <b-row class="px-3">
                    <h2 class="numberResult">há 30 dias</h2>
                  </b-row>
                </card>
              </b-col>
            </b-row>
          </card>
          <card class="no-border-card" body-classes="px-0 pb-1">
            <div class="px-3"><h2>Histórico</h2></div>

            <b-row class="px-3 pt-3">
              <b-col cols="12" lg="4" class="mb-1">
                <card class="no-border-card bg-orange">
                  <h3 class="text-white">Total Visitas</h3>
                  <b-row class="px-3">
                    <h2 class="text-white numberResult">
                      {{ dadosClienteSelecionado.visitas_total }}
                    </h2>
                  </b-row>
                </card>
              </b-col>
              <b-col cols="12" lg="4" class="mb-1">
                <card class="no-border-card bg-black">
                  <h3 class="text-white">Total Vendas</h3>
                  <b-row class="px-3">
                    <h2 class="text-white numberResult">
                      {{ dadosClienteSelecionado.gasto_total }} €
                    </h2>
                  </b-row>
                </card>
              </b-col>
              <b-col cols="12" lg="4" class="mb-1">
                <card class="no-border-card">
                  <h3>Ticket Médio</h3>
                  <b-row class="px-3">
                    <h2
                      class="numberResult"
                      v-if="Number(dadosClienteSelecionado.visitas_total) > 0"
                    >
                      {{
                        (
                          Number(dadosClienteSelecionado.gasto_total) /
                          Number(dadosClienteSelecionado.visitas_total)
                        ).toFixed(2)
                      }}
                      €
                    </h2>
                    <h2 class="numberResult" v-else>Nunca Visitou</h2>
                  </b-row>
                </card>
              </b-col>
            </b-row>
            <b-row class="px-3">
              <b-col cols="12" lg="4" class="mb-1">
                <card class="no-border-card">
                  <h3>Visitas 30D</h3>
                  <b-row class="px-3">
                    <h2 class="numberResult">
                      {{ dadosClienteSelecionado.visitas_30_dias }}
                    </h2>
                  </b-row>
                </card>
              </b-col>
              <b-col cols="12" lg="4" class="mb-1">
                <card class="no-border-card">
                  <h3>Visitas 90D</h3>
                  <b-row class="px-3">
                    <h2 class="numberResult">
                      {{ dadosClienteSelecionado.visitas_90_dias }}
                    </h2>
                  </b-row>
                </card>
              </b-col>
              <b-col cols="12" lg="4" class="mb-1">
                <card class="no-border-card">
                  <h3>Visitas 180D</h3>
                  <b-row class="px-3">
                    <h2 class="numberResult">
                      {{ dadosClienteSelecionado.visitas_180_dias }}
                    </h2>
                  </b-row>
                </card>
              </b-col>
            </b-row>
          </card>
          <b-row align-v="center" class="py-4 pt-3 d-flex align-items-stretch">
            <b-col cols="6" lg="6" class="mb-1 d-flex flex-column">
              <card class="no-border-card h-100" body-classes="px-3 pb-1">
                <div class="px-3 py-3">
                  <!-- Título dinâmico com botão de troca de categoria -->
                  <b-row class="px-3 align-items-center">
                    <!-- Botão anterior -->
                    <b-col cols="4" class="text-left">
                      <i
                        class="ni ni-bold-left pointer text-orange"
                        style="font-size: 20px"
                        @click="mudarCategoriaAnterior"
                      ></i>
                    </b-col>

                    <!-- Categoria atual -->
                    <b-col cols="4" class="text-center">
                      <h2 class="text-orange bold m-0 text-capitalize">
                        {{ categoriaFormatada }}
                      </h2>
                    </b-col>

                    <!-- Botão seguinte -->
                    <b-col cols="4" class="text-right">
                      <i
                        class="ni ni-bold-right pointer text-orange"
                        style="font-size: 20px"
                        @click="mudarCategoriaSeguinte"
                      ></i>
                    </b-col>
                  </b-row>
                </div>

                <!-- Lista dinâmica com base na categoria atual -->
                <b-list-group
                  flush
                  class="list my--3 py-3"
                  v-if="categoriaAtual && listAllConsumos[categoriaAtual]"
                >
                  <b-list-group-item
                    v-for="(item, index) in visibleItemsCategoria"
                    :key="index"
                    class="px-0"
                  >
                    <b-row align-v="center">
                      <b-col md="auto"> </b-col>
                      <b-col>
                        <h5>{{ item.name }} | {{ item.progress }} %</h5>
                        <base-progress
                          class="progress-xs mb-0"
                          :type="item.color"
                          :value="item.progress"
                        ></base-progress>
                        <span class="small-text bold">
                          {{ item.unidades_vendidas }} unidades vendidas |
                          {{ item.total_pago }}€
                        </span>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>

                <!-- Paginação -->
                <b-row
                  align-v="center"
                  class="text-center"
                  v-if="categoriaAtual"
                >
                  <!-- Botão anterior -->
                  <b-col cols="6" class="text-left">
                    <i
                      v-if="canGoPrevCategoria"
                      class="ni ni-bold-left pointer mx-2"
                      style="font-size: 20px"
                      @click="goToPrevPageCategoria"
                    ></i>
                  </b-col>

                  <!-- Botão seguinte -->
                  <b-col cols="6" class="text-right">
                    <i
                      v-if="canGoNextCategoria"
                      class="ni ni-bold-right pointer mx-2"
                      style="font-size: 20px"
                      @click="goToNextPageCategoria"
                    ></i>
                  </b-col>
                </b-row>
              </card>
            </b-col>

            <!-- Segunda coluna (Lista de refeições estática ou futura expansão) -->
            <b-col cols="6" lg="6" class="mb-1 d-flex flex-column">
              <card class="no-border-card h-100" body-classes="px-3 pb-1">
                <div class="px-3 py-3">
                  <h2>Lista de refeições</h2>
                </div>
                <b-list-group flush class="list my--3 py-3">
                  <b-list-group-item
                    v-for="(visita, index) in visitasPaginadas"
                    :key="index"
                    class="px-0 pointer"
                    @click="abrirModalVisita(visita)"
                  >
                    <b-row align-v="center">
                      <!-- Badge esquerda: há X dias -->
                      <b-col cols="2" class="text-center">
                        <div class="bg-gray br-25">
                          <span class="small bold">{{
                            calcularTempo(visita.data_visita)
                          }}</span>
                        </div>
                      </b-col>

                      <!-- Info central -->
                      <b-col cols="5">
                        <div>
                          <h5>{{ visita.restaurante || "Restaurante" }}</h5>
                        </div>
                        <div class="small">
                          {{ visita.refeicao }} –
                          {{ diaSemana(visita.data_visita) }}
                        </div>
                      </b-col>
                      <b-col cols="2">
                        <div class="font-weight-bold">
                          {{ visita.total_pago?.toFixed(0) || 0 }}€
                        </div>
                      </b-col>

                      <!-- Valor + ícone -->
                      <b-col cols="3" class="text-right">
                        <div
                          class="rounded-circle border border-danger text-danger d-inline-flex justify-content-center align-items-center"
                          style="width: 24px; height: 24px"
                        >
                          <span style="font-size: 16px">+</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>

                <!-- Paginação -->
                <b-row
                  align-v="center"
                  class="text-center"
                  v-if="
                    dadosClienteSelecionado.visitas?.length > pageSizeVisitas
                  "
                >
                  <b-col cols="6" class="text-left">
                    <i
                      v-if="canGoPrevVisitas"
                      class="ni ni-bold-left pointer mx-2"
                      style="font-size: 20px"
                      @click="goToPrevPageVisitas"
                    ></i>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <i
                      v-if="canGoNextVisitas"
                      class="ni ni-bold-right pointer mx-2"
                      style="font-size: 20px"
                      @click="goToNextPageVisitas"
                    ></i>
                  </b-col>
                </b-row>
              </card>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <b-modal
        v-model="modalVisita"
        title="Detalhes da Visita"
        size="lg"
        hide-footer
        dialog-class="modal-altura-fixa"
      >
        <template v-if="visitaSelecionada">
          <div class="modal-body-scrollable">
            <div class="mb-3">
              <strong>Data:</strong>
              {{ formatarData(visitaSelecionada.data_visita) }}<br />
              <strong>Refeição:</strong> {{ visitaSelecionada.refeicao }}<br />
              <strong>Restaurante:</strong>
              {{ visitaSelecionada.restaurante || "–" }}<br />
              <strong>Total:</strong>
              {{ visitaSelecionada.total_pago?.toFixed(2) || 0 }} €
            </div>

            <b-list-group flush>
              <b-list-group-item
                v-for="(item, index) in visitaSelecionada.consumos"
                :key="index"
              >
                <b-row align-v="center">
                  <b-col cols="6">
                    <strong>{{ item.produto }}</strong
                    ><br />
                    <small>{{ item.categoria }}</small>
                  </b-col>
                  <b-col cols="3"> {{ item.quantidade }} un. </b-col>
                  <b-col cols="3" class="text-right">
                    {{ item.pago.toFixed(2) }} €
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </div>
        </template>
      </b-modal>
    </div>
    <b-modal
      v-model="verFiltros"
      title="Aplicar filtros"
      size="lg"
      hide-footer
      dialog-class="modal-altura-fixa"
    >
      <template>
        <div class="drawer-content">
          <div class="modal-body-scrollable">
            <div class="content filtros-modal">
              <div class="drawer drawer-left bg-white shadow p-3 overflow-auto">
                <b-row>
                  <b-col md="6">
                    <h4
                      class="text-underline pointer"
                      @click="guardarSegmentacao = !guardarSegmentacao"
                    >
                      Guardar Segmentação
                    </h4>
                  </b-col>
                  <b-col md="6">
                    <h4
                      class="text-orange text-right pointer"
                      @click="limparFiltros"
                    >
                      Limpar
                    </h4>
                  </b-col>
                </b-row>
                <b-row
                  v-if="guardarSegmentacao"
                  class="align-items-center pt-3"
                >
                  <b-col md="8">
                    <b-form-input
                      v-model="nomeSegmentacao"
                      placeholder="Nome da segmentação"
                    />
                  </b-col>
                  <b-col md="4">
                    <b-button
                      variant="primary"
                      size="md"
                      block
                      @click="guardarFiltro"
                    >
                      Guardar Segmentação
                    </b-button>
                  </b-col>
                </b-row>

                <!-- Segmentações e restaurante -->
                <div class="pb-3 pt-3">
                  <label class="font-weight-bold">Segmentações gravadas</label>

                  <el-select
                    v-model="filtroSelecionado"
                    placeholder="Selecionar filtro guardado"
                    @change="aplicarFiltroGuardado"
                    style="width: 100%"
                  >
                    <el-option
                      v-if="filtros_utilizador.length === 0"
                      :value="0"
                      label="Sem filtros guardados"
                      disabled
                    />
                    <el-option
                      v-for="filtro in filtros_utilizador"
                      :key="filtro.id"
                      :label="filtro.nome"
                      :value="filtro.id"
                    />
                  </el-select>
                </div>

                <el-select
                  v-model="filtros.restaurante"
                  multiple
                  filterable
                  placeholder="Restaurantes"
                >
                  <el-option
                    v-for="option in restaurantes"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <!-- Filtros Demográficos -->
                <div class="spacer py-3"></div>
                <b-card no-body class="mb-2">
                  <b-card-header header-tag="header" role="tab">
                    <b-button
                      block
                      id="demografico"
                      v-b-toggle.filtroDemografico
                      variant="light"
                      class="text-left"
                      >Filtros demográficos</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="filtroDemografico"
                    accordion="filtros"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-row>
                        <!-- Género -->
                        <b-col md="4">
                          <label class="font-weight-bold">Género</label>
                          <b-form-checkbox-group
                            v-model="filtros.genero"
                            class="mb-3"
                            stacked
                          >
                            <b-form-checkbox value="Masculino"
                              >Masculino</b-form-checkbox
                            >
                            <b-form-checkbox value="Feminino"
                              >Feminino</b-form-checkbox
                            >
                            <b-form-checkbox value="Outros"
                              >Outros</b-form-checkbox
                            >
                          </b-form-checkbox-group>
                        </b-col>

                        <!-- Idade -->
                        <b-col md="4">
                          <label class="font-weight-bold">Idade</label>
                          <b-form-checkbox-group
                            v-model="filtros.idade"
                            class="mb-3"
                            stacked
                          >
                            <b-form-checkbox value="18-24"
                              >18–24</b-form-checkbox
                            >
                            <b-form-checkbox value="25-34"
                              >25–34</b-form-checkbox
                            >
                            <b-form-checkbox value="34-44"
                              >34–44</b-form-checkbox
                            >
                            <b-form-checkbox value="45-54"
                              >45–54</b-form-checkbox
                            >
                            <b-form-checkbox value="55+">55+</b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-col>

                        <!-- Estado -->
                        <b-col md="4">
                          <label class="font-weight-bold">Estado</label>
                          <b-form-checkbox-group
                            v-model="filtros.estado"
                            stacked
                          >
                            <b-form-checkbox value="Ativo"
                              >Ativo</b-form-checkbox
                            >
                            <b-form-checkbox value="Inativo"
                              >Inativo</b-form-checkbox
                            >
                          </b-form-checkbox-group>
                        </b-col>
                      </b-row>

                      <label class="font-weight-bold mt-3"
                        >Data de inscrição</label
                      >
                      <b-row>
                        <!-- Género -->
                        <b-col md="6">
                          <b-form-datepicker
                            v-model="filtros.data_inscricao_de"
                            placeholder="De"
                            reset-button
                            selected-variant="primary"
                            reset-button-title="Limpar"
                            class="text-orange"
                          ></b-form-datepicker>
                        </b-col>
                        <b-col md="6">
                          <b-form-datepicker
                            selected-variant="primary"
                            reset-button
                            reset-button-title="Limpar"
                            v-model="filtros.data_inscricao_ate"
                            placeholder="Até"
                          ></b-form-datepicker>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- Filtros Comportamentos -->
                <b-card no-body class="mb-2">
                  <b-card-header header-tag="header" role="tab">
                    <b-button
                      block
                      v-b-toggle.filtroComportamento
                      variant="light"
                      class="text-left"
                      id="comportamento"
                      >Filtros de comportamentos</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="filtroComportamento"
                    accordion="filtros"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <label>Total de visitas</label>
                      <b-row>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.total_visitas_de"
                            type="number"
                            placeholder="De"
                          ></b-form-input>
                        </b-col>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.total_visitas_ate"
                            type="number"
                            placeholder="Até"
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <label class="mt-3">Total gasto (€)</label>
                      <b-row>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.total_gasto_min"
                            type="number"
                            placeholder="Min"
                          ></b-form-input>
                        </b-col>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.total_gasto_max"
                            type="number"
                            placeholder="Max"
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <label class="mt-3">Ticket médio (€)</label>
                      <b-row>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.ticket_medio_min"
                            type="number"
                            placeholder="Min"
                          ></b-form-input>
                        </b-col>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.ticket_medio_max"
                            type="number"
                            placeholder="Max"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- Filtros Consumo -->
                <b-card no-body class="mb-2">
                  <b-card-header header-tag="header" role="tab">
                    <b-button
                      block
                      id="consumo"
                      v-b-toggle.filtroConsumo
                      variant="light"
                      class="text-left"
                      >Filtros de consumo</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="filtroConsumo"
                    accordion="filtros"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <div
                        v-for="cat in categoriasUnicas"
                        :key="cat"
                        class="mb-3"
                      >
                        <label class="mb-1">{{ cat }} (€)</label>
                        <b-row>
                          <b-col>
                            <b-form-input
                              placeholder="Min"
                              type="number"
                              v-model="filtros[slugify(cat) + '_min']"
                            />
                          </b-col>
                          <b-col>
                            <b-form-input
                              placeholder="Max"
                              type="number"
                              v-model="filtros[slugify(cat) + '_max']"
                            />
                          </b-col>
                        </b-row>
                      </div>

                      <label class="mt-3">Consumo por produto</label>
                      <div
                        v-for="(produto, index) in filtros.produtos"
                        :key="index"
                        class="mb-3"
                      >
                        <b-row>
                          <!-- Nome do produto -->
                          <b-col>
                            <b-form-input
                              v-model="produto.nome"
                              placeholder="Nome do produto"
                            />
                          </b-col>

                          <!-- Nº de vezes + botão X -->
                          <b-col cols="4">
                            <b-input-group>
                              <b-form-input
                                v-model="produto.vezes"
                                type="number"
                                placeholder="#vezes"
                              />
                              <b-input-group-append>
                                <b-button
                                  v-if="index > 0"
                                  size="sm"
                                  variant="orange"
                                  @click="removerProduto(index)"
                                >
                                  <i class="fas fa-times"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
                        </b-row>
                      </div>

                      <b-button
                        variant="primary"
                        size="md"
                        @click="adicionarProduto"
                      >
                        + Adicionar condição
                      </b-button>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- Filtros de comunicação -->
                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button
                      block
                      id="comunicacao"
                      v-b-toggle.filtroComunicacao
                      variant="light"
                      class="text-left"
                      >Filtros de comunicação</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="filtroComunicacao"
                    accordion="filtros"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <label>Total de mensagens</label>
                      <b-row>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.total_mensagens_min"
                            type="number"
                            placeholder="Min"
                          ></b-form-input>
                        </b-col>
                        <b-col md="6">
                          <b-form-input
                            v-model="filtros.total_mensagens_max"
                            type="number"
                            placeholder="Max"
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <label class="mt-3">Última mensagem enviada</label>
                      <b-row class="mt-2">
                        <b-col
                          v-for="opt in mensagensPeriodo"
                          :key="opt"
                          cols="4"
                          class="mb-2"
                        >
                          <b-button
                            size="md"
                            block
                            :variant="
                              filtros.periodo_mensagens.includes(opt)
                                ? 'outline-primary'
                                : ''
                            "
                            @click="togglePeriodoMensagem(opt)"
                          >
                            {{ opt }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <!-- Botão final -->
              <div
                class="drawer-footer bg-white pt-2 border-top"
                style="position: sticky; bottom: 0"
              >
                <b-button
                  variant="primary"
                  size="lg"
                  block
                  @click="aplicarFiltrosManualmente"
                >
                  Ver {{ resultadosFiltrados }} resultados
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import LoadingOverlay from "@/components/Loading/LoadingOverlay";
import clientPaginationMixin from "./TableHelper";
import swal from "sweetalert2";
import users from "./users2";
import axios from "axios";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    LoadingOverlay,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      propsToSearch: [
        "nome",
        "top_prato",
        "top_bebida",
        "top_sobremesa",
        "top_restaurante",
      ],
      itemsPerPage: 5,
      dadosClienteSelecionado: [],
      listAllConsumos: {},
      categoriasUnicas: [],
      categoriaAtual: "BEBIDAS",
      currentPageCategoria: 1,
      verPerfil: false,
      verFiltros: false,
      rendered: false,
      comidaMostar: true,
      currentPageVisitas: 1,
      pageSizeVisitas: 5,
      modalVisita: false,
      visitaSelecionada: null,
      tableColumns: [
        {
          type: "selection",
        },
        {
          prop: "nome",
          label: "Nome",
        },
        {
          prop: "visitas_total",
          label: "Total de Visitas",
          sortable: true,
        },
        {
          prop: "gasto_total",
          label: "Total Gasto",
          sortable: true,
        },
        {
          prop: "ultima_visita",
          label: "Ultima Visita",
          sortable: true,
        },
        {
          prop: "top_restaurante",
          label: "Top Restaurante",
        },
        {
          prop: "top_prato",
          label: "Top Prato",
        },
        {
          prop: "top_bebida",
          label: "Top Bebida",
        },
        {
          prop: "top_sobremesa",
          label: "Top Sobremesa",
        },
      ],
      listComidas: [],
      listBebidas: [],
      tableData: users,
      selectedRows: [],
      currentPageRankings: 1,
      currentPageBebidas: 1,
      pageSize: 5,
      pageSizeBebidas: 5,
      // Filtros
      filtros: {
        deep: true,
        handler() {
          this.debouncedFiltrar();
        },
        segmentacao: null,
        restaurante: [],
        genero: [],
        idade: [],
        estado: [],
        data_inscricao_de: null,
        data_inscricao_ate: null,
        total_visitas_de: null,
        total_visitas_ate: null,
        total_gasto_min: null,
        total_gasto_max: null,
        ticket_medio_min: null,
        ticket_medio_max: null,
        produtos: [{ nome: "", vezes: null }],
        total_mensagens_min: null,
        total_mensagens_max: null,
        periodo_mensagens: [],
      },
      filtros_utilizador: [],
      nomeSegmentacao: "",
      filtroSelecionado: null,
      guardarSegmentacao: false,
      mensagensPeriodo: [
        "Hoje",
        "Esta semana",
        "Este mês",
        "Ultimos 3 meses",
        "Mais de 6 meses",
      ],
      resultadosFiltrados: 234,
      restaurantes: [], // carregar de API se quiseres
    };
  },
  computed: {
    visitasPaginadas() {
      const start = (this.currentPageVisitas - 1) * this.pageSizeVisitas;
      return (
        this.dadosClienteSelecionado.visitas?.slice(
          start,
          start + this.pageSizeVisitas
        ) || []
      );
    },
    canGoNextVisitas() {
      const total = this.dadosClienteSelecionado.visitas?.length || 0;
      return this.currentPageVisitas < Math.ceil(total / this.pageSizeVisitas);
    },
    canGoPrevVisitas() {
      return this.currentPageVisitas > 1;
    },
    pageCount() {
      return Math.ceil(this.listComidas.length / this.pageSize);
    },
    visibleItems() {
      const start = (this.currentPageRankings - 1) * this.pageSize;
      return this.listComidas.slice(start, start + this.pageSize);
    },
    categoriaFormatada() {
      const s = this.categoriaAtual;
      return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "";
    },
    canGoPrev() {
      return this.currentPageRankings > 1;
    },
    canGoNext() {
      return this.currentPageRankings < this.pageCount;
    },

    pageCountBebidas() {
      return Math.ceil(this.listBebidas.length / this.pageSizeBebidas);
    },
    visibleItemsBebidas() {
      const start = (this.currentPageBebidas - 1) * this.pageSizeBebidas;
      return this.listBebidas.slice(start, start + this.pageSizeBebidas);
    },

    canGoPrevBebidas() {
      return this.currentPageBebidas > 1;
    },
    canGoNextBebidas() {
      return this.currentPageBebidas < this.pageCountBebidas;
    },
    visibleItemsCategoria() {
      const start = (this.currentPageCategoria - 1) * this.itemsPerPage;
      return (
        this.listAllConsumos[this.categoriaAtual]?.slice(
          start,
          start + this.itemsPerPage
        ) || []
      );
    },
    canGoNextCategoria() {
      const total = this.listAllConsumos[this.categoriaAtual]?.length || 0;
      return this.currentPageCategoria < Math.ceil(total / this.itemsPerPage);
    },
    canGoPrevCategoria() {
      return this.currentPageCategoria > 1;
    },
  },
  watch: {
    filtros: {
      deep: true,
      handler() {
        this.aplicarFiltros();
      },
    },
  },
  methods: {
    limparFiltros() {
      // Repor filtros ao estado original
      this.filtros = {
        deep: true,
        handler() {
          this.debouncedFiltrar();
        },
        segmentacao: null,
        restaurante: [],
        genero: [],
        idade: [],
        estado: [],
        data_inscricao_de: null,
        data_inscricao_ate: null,
        total_visitas_de: null,
        total_visitas_ate: null,
        total_gasto_min: null,
        total_gasto_max: null,
        ticket_medio_min: null,
        ticket_medio_max: null,
        produtos: [{ nome: "", vezes: null }],
        total_mensagens_min: null,
        total_mensagens_max: null,
        periodo_mensagens: [],
      };

      this.filtroSelecionado = null;
      this.nomeSegmentacao = "";

      this.debouncedFiltrar(); // Atualiza a lista com filtros limpos
    },
    verificarFiltrosPreenchidos(filtro) {
      return (
        filtro.segmentacao ||
        filtro.restaurante.length > 0 ||
        filtro.genero.length > 0 ||
        filtro.idade.length > 0 ||
        filtro.estado.length > 0 ||
        filtro.data_inscricao_de ||
        filtro.data_inscricao_ate ||
        filtro.total_visitas_de ||
        filtro.total_visitas_ate ||
        filtro.total_gasto_min ||
        filtro.total_gasto_max ||
        filtro.ticket_medio_min ||
        filtro.ticket_medio_max ||
        filtro.produtos.some((p) => p.nome || p.vezes) ||
        filtro.total_mensagens_min ||
        filtro.total_mensagens_max ||
        filtro.periodo_mensagens.length > 0
      );
    },

    togglePeriodoMensagem(opt) {
      const i = this.filtros.periodo_mensagens.indexOf(opt);
      if (i > -1) {
        this.filtros.periodo_mensagens.splice(i, 1);
      } else {
        this.filtros.periodo_mensagens.push(opt);
      }
    },
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    aplicarFiltros() {
      this.rendered = false;
      const resultados = this.tableDataOriginal.filter((cliente) => {
        // Filtro: género (corrigido para usar 'sexo')
        if (
          this.filtros.genero.length &&
          !this.filtros.genero.includes(cliente.sexo)
        ) {
          return false;
        }

        // Filtro: estado
        if (this.filtros.estado.length) {
          const ativo = cliente.visitas_30_dias > 0;
          const corresponde =
            (ativo && this.filtros.estado.includes("Ativo")) ||
            (!ativo && this.filtros.estado.includes("Inativo"));

          if (!corresponde) return false;
        }

        // Filtro: idade (com base em data_nascimento)
        if (this.filtros.idade.length && cliente.data_nascimento) {
          const birthDate = new Date(cliente.data_nascimento);
          const today = new Date();
          let idadeAtual = today.getFullYear() - birthDate.getFullYear();
          const m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            idadeAtual--;
          }
          const faixa = this.filtros.idade.find((faixa) => {
            const [min, max] = faixa.includes("+")
              ? [parseInt(faixa), 200]
              : faixa.split("-").map(Number);
            return idadeAtual >= min && idadeAtual <= max;
          });
          if (!faixa) return false;
        }

        // Filtro: restaurante
        if (this.filtros.restaurante.length) {
          const restaurantesVisitados = (cliente.visitas || []).map(
            (v) => v.restaurante
          );
          const passou = restaurantesVisitados.some((r) =>
            this.filtros.restaurante.includes(r)
          );
          if (!passou) {
            return false;
          }
        }
        if (this.filtros.data_inscricao_de || this.filtros.data_inscricao_ate) {
          const inscricao = new Date(cliente.dt_created);

          if (
            this.filtros.data_inscricao_de &&
            inscricao < new Date(this.filtros.data_inscricao_de)
          ) {
            return false;
          }

          if (
            this.filtros.data_inscricao_ate &&
            inscricao > new Date(this.filtros.data_inscricao_ate)
          ) {
            return false;
          }
        }
        // Total visitas
        if (
          this.filtros.total_visitas_de &&
          cliente.visitas_total < this.filtros.total_visitas_de
        )
          return false;
        if (
          this.filtros.total_visitas_ate &&
          cliente.visitas_total > this.filtros.total_visitas_ate
        )
          return false;

        // Total gasto
        if (
          this.filtros.total_gasto_min &&
          cliente.gasto_total < this.filtros.total_gasto_min
        )
          return false;
        if (
          this.filtros.total_gasto_max &&
          cliente.gasto_total > this.filtros.total_gasto_max
        )
          return false;

        // Ticket médio
        const ticketMedio = cliente.visitas_total
          ? cliente.gasto_total / cliente.visitas_total
          : 0;
        if (
          this.filtros.ticket_medio_min &&
          ticketMedio < this.filtros.ticket_medio_min
        )
          return false;
        if (
          this.filtros.ticket_medio_max &&
          ticketMedio > this.filtros.ticket_medio_max
        )
          return false;

        // Filtros por categoria
        const categorias = [
          ...(cliente.consumos_comida || []),
          ...(cliente.consumos_bebidas || []),
        ];
        for (const cat of this.categoriasUnicas) {
          const keyMin = this.slugify(cat) + "_min";
          const keyMax = this.slugify(cat) + "_max";
          const soma = categorias
            .filter((p) => p.categoria === cat)
            .reduce((total, p) => total + p.total_pago, 0);

          if (this.filtros[keyMin] !== null && soma < this.filtros[keyMin])
            return false;
          if (this.filtros[keyMax] !== null && soma > this.filtros[keyMax])
            return false;
        }

        // Filtro por produtos específicos
        if (this.filtros.produtos.some((p) => p.nome && p.vezes != null)) {
          const produtos = [
            ...(cliente.consumos_comida || []),
            ...(cliente.consumos_bebidas || []),
          ];
          for (const filtro of this.filtros.produtos) {
            if (!filtro.nome || filtro.vezes == null) continue;

            const match = produtos.find(
              (p) =>
                p.produto === filtro.nome && p.total_quantidade >= filtro.vezes
            );
            if (!match) return false;
          }
        }

        return true;
      });
      this.tableData = resultados;
      this.resultadosFiltrados = resultados.length;
      this.rendered = true;
    },
    adicionarProduto() {
      this.filtros.produtos.push({ nome: "", vezes: null });
    },
    aplicarFiltrosManualmente() {
      this.aplicarFiltros(); // aplica os filtros
      this.verFiltros = false; // fecha o painel
      this.rendered = true; // força render opcional
    },
    removerProduto(index) {
      this.filtros.produtos.splice(index, 1);
    },
    extrairCategoriasUnicas() {
      const set = new Set();

      this.tableDataOriginal.forEach((cliente) => {
        const todasCategorias = [
          ...(cliente.consumos || []),
          ...(cliente.consumos_comida || []),
          ...(cliente.consumos_bebidas || []),
        ];

        todasCategorias.forEach((item) => {
          if (item.categoria) {
            set.add(item.categoria.trim());
          }
        });
      });

      this.categoriasUnicas = Array.from(set);

      // inicializar os campos de filtro por categoria dinamicamente
      this.categoriasUnicas.forEach((cat) => {
        const key = this.slugify(cat);
        this.$set(this.filtros, `${key}_min`, null);
        this.$set(this.filtros, `${key}_max`, null);
      });
    },

    slugify(str) {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove acentos
        .toLowerCase()
        .replace(/\s+/g, "_") // espaços por _
        .replace(/[^a-z0-9_]/g, ""); // remove chars não válidos
    },

    async guardarFiltro() {
      try {
        const token = localStorage.getItem("tokenAbitue");
        const nome = this.nomeSegmentacao;
        const filtro = this.filtros;

        // Verificar se pelo menos um campo está preenchido
        const filtroPreenchido = this.verificarFiltrosPreenchidos(filtro);

        if (!filtroPreenchido) {
          console.warn("Nenhum filtro preenchido. Nada foi guardado.");
          return;
        }
        if (nome.trim() == "") {
          console.warn("Colocar um nome no filtro");
          return;
        }

        const response = await axios.post(
          "http://localhost:3001/api/filtros",
          { nome, filtro },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Filtro criado:", response.data);

        // Refresh aos filtros guardados
        await this.carregarFiltros();

        // Limpar o nome da segmentação
        this.nomeSegmentacao = "";
      } catch (err) {
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        } else {
          console.error("Erro ao criar filtro:", err);
        }
      }
    },

    async atualizarFiltro(id, nome, filtro) {
      try {
        const token = localStorage.getItem("tokenAbitue");

        const response = await axios.put(
          `http://localhost:3001/api/filtros/${id}`,
          { nome, filtro },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Filtro atualizado:", response.data);
      } catch (err) {
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        } else {
          console.error("Erro ao atualizar filtro:", err);
        }
      }
    },
    async carregarFiltros() {
      try {
        const token = localStorage.getItem("tokenAbitue");

        const response = await axios.get("http://localhost:3001/api/filtros", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        this.filtros_utilizador = response.data;
      } catch (err) {
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        } else {
          console.error("Erro ao carregar filtros:", err);
        }
      }
    },

    aplicarFiltroGuardado(idSelecionado) {
      const filtroSelecionado = this.filtros_utilizador.find(
        (f) => f.id === idSelecionado
      );

      if (!filtroSelecionado || !filtroSelecionado.filtro_json) return;

      try {
        const filtro = JSON.parse(filtroSelecionado.filtro_json);
        this.filtros = { ...this.filtros, ...filtro }; // aplica os dados ao filtro atual
        this.debouncedFiltrar(); // dispara o filtro se quiseres efeito imediato
      } catch (error) {
        console.error("Erro ao aplicar filtro guardado:", error);
      }
    },
    async apagarFiltro(id) {
      try {
        const token = localStorage.getItem("tokenAbitue");

        await axios.delete(`http://localhost:3001/api/filtros/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("Filtro apagado com sucesso");
      } catch (err) {
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        } else {
          console.error("Erro ao apagar filtro:", err);
        }
      }
    },
    async carregarRestaurantes() {
      try {
        const token = localStorage.getItem("tokenAbitue");

        const response = await axios.get(
          "http://localhost:3001/api/restaurantes",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.restaurantes = response.data.map((rest) => ({
          value: rest.nome,
          label: rest.nome,
        }));
        console.log(this.restaurantes, "this.restaurantes");
      } catch (err) {
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        } else {
          console.error("Erro ao carregar restaurantes:", err);
        }
      }
    },
    goToNextPageVisitas() {
      if (this.canGoNextVisitas) this.currentPageVisitas++;
    },
    goToPrevPageVisitas() {
      if (this.canGoPrevVisitas) this.currentPageVisitas--;
    },
    abrirModalVisita(visita) {
      this.visitaSelecionada = visita;
      this.modalVisita = true;
    },
    calcularTempo(data) {
      if (!data) return "–";

      const hoje = new Date();
      const d = new Date(data);

      // Zera horas para comparar só datas
      d.setHours(0, 0, 0, 0);
      hoje.setHours(0, 0, 0, 0);

      const diffDias = Math.floor((hoje - d) / (1000 * 60 * 60 * 24));

      if (diffDias === 0) return "hoje";

      if (diffDias >= 365) {
        const anos = Math.floor(diffDias / 365);
        return `há ${anos} ano${anos > 1 ? "s" : ""}`;
      }

      if (diffDias >= 31) {
        const meses = Math.floor(diffDias / 30.42);
        return `há ${meses} ${meses > 1 ? "meses" : "mês"}`;
      }

      return `há ${diffDias} dia${diffDias > 1 ? "s" : ""}`;
    },
    diaSemana(data) {
      const dias = [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
      ];
      return dias[new Date(data).getDay()];
    },
    formatarData(data) {
      const d = new Date(data);
      return d.toLocaleDateString("pt-PT", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    abrirModalVisita(visita) {
      this.visitaSelecionada = visita;
      this.modalVisita = true;
    },
    mudarCategoriaAnterior() {
      const indexAtual = this.categoriasUnicas.indexOf(this.categoriaAtual);
      const novoIndex =
        (indexAtual - 1 + this.categoriasUnicas.length) %
        this.categoriasUnicas.length;
      this.categoriaAtual = this.categoriasUnicas[novoIndex];
      this.currentPageCategoria = 1;
    },
    mudarCategoriaSeguinte() {
      const indexAtual = this.categoriasUnicas.indexOf(this.categoriaAtual);
      const novoIndex = (indexAtual + 1) % this.categoriasUnicas.length;
      this.categoriaAtual = this.categoriasUnicas[novoIndex];
      this.currentPageCategoria = 1;
    },
    mudarCategoria() {
      const indexAtual = this.categoriasUnicas.indexOf(this.categoriaAtual);
      const proximoIndex = (indexAtual + 1) % this.categoriasUnicas.length;
      this.categoriaAtual = this.categoriasUnicas[proximoIndex];
      this.currentPageCategoria = 1;
    },
    goToNextPageCategoria() {
      if (this.canGoNextCategoria) this.currentPageCategoria++;
    },
    goToPrevPageCategoria() {
      if (this.canGoPrevCategoria) this.currentPageCategoria--;
    },
    paginationChanged(page) {
      this.pagination.currentPage = page;
    },
    verPerfilCliente(array) {
      this.verPerfil = true;
      this.dadosClienteSelecionado = array;
      this.currentPageCategoria = 1;
      this.listAllConsumos = {};
      this.categoriasUnicas = [];
      this.categoriaAtual = "";

      const consumos = [
        ...this.dadosClienteSelecionado.consumos_comida,
        ...this.dadosClienteSelecionado.consumos_bebidas,
      ];

      const agrupado = {};

      for (const consumo of consumos) {
        const categoria = consumo.categoria || "Outros";
        const nome = consumo.produto;

        if (!agrupado[categoria]) agrupado[categoria] = {};

        if (!agrupado[categoria][nome]) {
          agrupado[categoria][nome] = {
            name: nome,
            quantidade: 0,
            total_pago: 0,
          };
        }

        agrupado[categoria][nome].quantidade += consumo.total_quantidade;
        agrupado[categoria][nome].total_pago += consumo.total_pago ?? 0;
      }

      for (const categoria in agrupado) {
        const lista = Object.values(agrupado[categoria]);
        const totalUnidades = lista.reduce(
          (sum, item) => sum + item.quantidade,
          0
        );

        const listaFormatada = lista
          .sort((a, b) => b.quantidade - a.quantidade)
          .map((item) => ({
            name: item.name,
            color: "orange",
            image: "img/theme/vue.jpg",
            progress: totalUnidades
              ? Math.round((item.quantidade / totalUnidades) * 100)
              : 0,
            unidades_vendidas: item.quantidade,
            total_pago: item.total_pago,
          }));

        this.listAllConsumos[categoria] = listaFormatada;
        this.categoriasUnicas.push(categoria);
      }

      // Define categoria inicial
      this.categoriaAtual = this.categoriasUnicas[0] || "";
    },
    goToPrevPageBebidas() {
      if (this.canGoPrevBebidas) this.currentPageBebidas--;
    },
    goToNextPageBebidas() {
      if (this.canGoNextBebidas) this.currentPageBebidas++;
    },
    goToPrevPage() {
      if (this.canGoPrev) this.currentPageRankings--;
    },
    goToNextPage() {
      if (this.canGoNext) this.currentPageRankings++;
    },
    tempoDesde(dataStr) {
      if (dataStr == "#N/A") {
        return "Nunca visitou";
      }

      const hoje = new Date();
      const data = new Date(dataStr);

      data.setHours(0, 0, 0, 0);
      hoje.setHours(0, 0, 0, 0);

      let diffMs = hoje - data;

      if (diffMs < 0) return "no futuro";

      const diasTotais = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      let anos = Math.floor(diasTotais / 365);
      let meses = Math.floor((diasTotais % 365) / 30.42);
      let dias = Math.floor(diasTotais - (anos * 365 + meses * 30.42));

      // Apenas a unidade mais relevante
      if (anos > 0) return `há ${anos} ano${anos > 1 ? "s" : ""}`;
      if (meses > 0) return `há ${meses} ${meses > 1 ? "meses" : "mês"}`;
      return `há ${dias} dia${dias > 1 ? "s" : ""}`;
    },
    calcularIdade(dataNascimento) {
      const hoje = new Date();
      const nascimento = new Date(dataNascimento);

      let idade = hoje.getFullYear() - nascimento.getFullYear();
      const mesAtual = hoje.getMonth();
      const mesNascimento = nascimento.getMonth();

      // Se ainda não fez anos este ano, subtrai 1
      if (
        mesAtual < mesNascimento ||
        (mesAtual === mesNascimento && hoje.getDate() < nascimento.getDate())
      ) {
        idade--;
      }

      return idade;
    },
    handleLike(index, row) {
      swal.fire({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill",
      });
    },
    async getCartoes() {
      this.rendered = false;
      try {
        const token = localStorage.getItem("tokenAbitue"); // ou onde estiveres a guardar o JWT
        const response = await axios.get("http://localhost:3001/api/cartoes", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.rendered = true;
        this.tableData = response.data;
        this.tableDataOriginal = JSON.parse(JSON.stringify(response.data));
        console.log(response.data);
      } catch (err) {
        if (err.response && err.response.status === 403) {
          this.rendered = true;
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        }
      }
    },
    handleEdit(index, row) {
      swal.fire({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill",
      });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteRow(row);
            swal.fire({
              title: "Deleted!",
              text: `You deleted ${row.name}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          }
        });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
  async mounted() {
    await this.getCartoes();
    await this.carregarRestaurantes();
    await this.extrairCategoriasUnicas();
    await this.carregarFiltros();
    this.debouncedFiltrar = this.debounce(this.aplicarFiltros, 300);
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.drawer-left {
  width: 100%;
}
button#demografico {
  background: rgba(89, 255, 160, 0.3);
  border: none;
  color: #525f7f;
}
button#comportamento {
  background: rgba(141, 117, 252, 0.3);
  border: none;
  color: #525f7f;
}
button#consumo {
  background: rgba(255, 93, 44, 0.3);
  border: none;
  color: #525f7f;
}
button#comunicacao {
  background: rgba(52, 0, 104, 0.2);
  border: none;
  color: #525f7f;
}
.drawer-content {
  padding-bottom: 10px; /* espaço para o botão fixo */
}

.drawer-footer {
  z-index: 10;
  background: white;
}
.modal-header {
  padding: 1.5rem !important;
}
</style>
